import React from "react";

export const Services = (props) => {
  return (
    <div id="srv">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6" style={{ marginBottom: "30px" }}>
            {" "}
            <img src="img/maalaus1.jpg" className="img-responsive" alt="" />{" "}
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>Palvelut</h2> 
              {/* <h4>Toimialue Uusimaa</h4>  */}
                <div className="list-style">
                  <div>
                    <ul>
                      {props.data
                        ? props.data.Services.map((d, i) => (
                            <li key={`${d}-${i}`}>{d}</li>
                          ))
                        : "loading"}
                    </ul>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
